import React, { memo, useTransition } from "react";
import { ArchiveBoxArrowDownIcon, Tooltip, ArchiveBoxIcon } from "@";

const ToggleArchiveStatus = memo(function ToggleArchiveStatus({ row, click }) {
  const isArchive = row.isArchive || row.isArchived;
  const tooltipId = `action-archive-${isArchive ? "false" : "true"}-${row.id}`;
  const tooltipTitle = isArchive ? "غير مؤرشف" : "ارشفة";
  const Icon = isArchive ? ArchiveBoxIcon : ArchiveBoxArrowDownIcon;
  const [isPending, startTransition] = useTransition();

  return (
    <div>
      <span
        onClick={() => startTransition(() => click(row.id, !isArchive))}
        className={`icon-style group/toggle cursor-pointer hover:!bg-amber-50 hover:!text-amber-600 dark:hover:!bg-amber-950/40 dark:hover:!text-amber-400 ${
          isPending ? "animate-pulse opacity-60" : ""
        }`}
        data-tooltip-placement="right"
        data-tooltip-target={tooltipId}
      >
        <Icon className="w-5 transition-transform group-hover/toggle:scale-110" />
      </span>
      <Tooltip
        className="dark:bg-gray-600"
        title={tooltipTitle}
        id={tooltipId}
      />
    </div>
  );
});

export default ToggleArchiveStatus;
